import { IUser } from "@/models/IUser";

import { BaseRepository } from "@/repositories/BaseRepository";

class UserRepository extends BaseRepository<IUser> {
    constructor() {
        super("/users");
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    public async sendRequestAccess(data: any): Promise<IUser> {
        return await this.post<IUser>("/SendRequestAccess", data);
    }
}

const userRepository = new UserRepository();

export { UserRepository, userRepository };
